import { allLocationsId } from "../../../backendApi/CollectionApi";
import { buildUrlWithParams } from "../../../utils/browserQueryParams";
import { nonDefaultPartial } from "../../../utils/object";
import { initialSearchParams } from "./CollectionOverviewState";
export const searchParams = (newParams)=>{
    const nonDefaultParams = nonDefaultPartial(newParams, initialSearchParams);
    // Special case: allLocationsId must be preserved even though it's the default
    if (newParams.location === allLocationsId) nonDefaultParams.location = allLocationsId;
    const url = buildUrlWithParams(nonDefaultParams);
    return url.search;
};
